import React from "react";
// @ts-ignore
import { tw } from "@careinfo/tailwind";
import TextField from "../Reusable/TextField";

const FormsForm = ({ data, register, errors }: any) => {
  return (
    // <div className={tw`grid grid-cols-2 gap-4`}>
    //   {data?.map((field: any, index: number) => (
    //     <TextField
    //       key={index}
    //       type={field.type}
    //       label={field.label}
    //       register={register(field.name)}
    //       error={errors?.[field.name]}
    //     />
    //   ))}
    // </div>
    <div className="grid grid-cols-2 gap-4">
      <TextField
        label="Title"
        placeholder="Enter form title"
        type="text"
        register={register("title", { required: "Title is required" })}
        errors={errors?.title}
      />
    </div>
  );
};

export default FormsForm;
